<template>
  <v-card class="pwc-product-item" :style="cStyle">
    <v-img
      :src="product.coverUrl"
      :height="imgHeight"
    />
    <v-card-title primary-title>
      <div>
        <div class="pwc-product-title">{{ product.name }}</div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="pwc-product-intro" v-html="product.productDesc" />
      </div>
    </v-card-title>
    <v-card-actions>
      <v-spacer />
      <v-btn flat outline color="#D04A02" @click="register(product)">申请项目</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  props: {
    product: {
      type: Object,
      default: () => { return {} }
    },
    register: {
      type: Function,
      default: () => {}
    },
    imgHeight: {
      type: String,
      default: '200px'
    },
    imgWidth: {
      type: String,
      default: '300px'
    }
  },
  computed: {
    cStyle() {
      return {
        width: this.imgWidth
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-product-item {
    width: 300px;
    margin: 12px;
    .pwc-product-title {
        font-size: 16px;
        font-weight: bold;
    }
    .pwc-product-intro {
        margin-top: 6px;
        font-size: 14px;
        color:#9e9e9e;
    }
}
</style>
